import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { adminAuthRoutes, adminRoutes } from "./routes/adminRoutes";
import Authmiddleware from "./routes/middleware/Authmiddleware";
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "react-toastify/dist/ReactToastify.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "./assets/scss/theme.scss";
import {
	adminPrefix,
	providerPrefix,
	salesDeveloperPrefix,
} from "configs/routePrefix";
import { websiteAuthRoutes, websiteRoutes } from "./routes/websiteRoutes";
import { salesRepAuthRoutes, salesRepRoutes } from "./routes/providerRoutes";
import { appendFilters } from "store/filter/actions";
import NonAuthBuyerLayout from "components/Website/NonAuthBuyerLayout";
import "./App.scss";
import ScrollToTop from "components/Website/ScrollToTop";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, setInterests, setLoadingHome } from "store/Auth/actions";
import InterestServices from "services/Website/InterestServices";
import { SuccessOk } from "configs/statusCode";
import CategoriesService from "services/Admin/CategoriesService";
import AreasService from "services/Admin/AreasService";
import UnitTypesService from "services/Admin/UnitTypesService";
import FinishingTypesService from "services/Admin/FinishingTypesService";
import http from "services/HttpService";
import {
	salesDeveloperAuthRoutes,
	salesDeveloperRoutes,
} from "routes/salesDeveloperRoues";
import Loader from "common/Loader";
import HomeService from "services/Website/HomeService";

const App = (props) => {
	const [loading, setLoading] = useState(false);
	const [type, setType] = useState(false);
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const loadedBefore = useSelector((state) => state.Auth?.loadedBefore);
	const loadingHome = useSelector((state) => state.Auth?.loadingHome);
	const interestServices = new InterestServices();
	const homeService = new HomeService();

	useEffect(() => {
		if (type === "user" && window?.location?.pathname !== "/") {
			if (!loadedBefore) {
				dispatch(setLoadingHome({ loadingHome: true }));
			}
			homeService
				.getRangeFilter()
				.then((response) => {
					if (response && response.status === SuccessOk) {
						dispatch(
							appendFilters({
								budgetRange:
									response.data.minPrice == response.data.maxPrice
										? [1, response.data.maxPrice]
										: [response.data.minPrice, response.data.maxPrice],
								sizeRange:
									response.data.minSize == response.data.maxSize
										? [1, response.data.maxSize]
										: [response.data.minSize, response.data.maxSize],
								budget: [response.data.minPrice, response.data.maxPrice],
								size: [response.data.minSize, response.data.maxSize],
								getRanges: true,
							})
						);
					}
					setTimeout(
						() =>
							dispatch(
								setLoadingHome({ loadingHome: false, loadedBefore: true })
							),
						2000
					);
				})
				.catch(() =>
					setTimeout(
						() =>
							dispatch(
								setLoadingHome({ loadingHome: false, loadedBefore: true })
							),
						2000
					)
				);
		}
		// if (type === "user") {
		// 	setLoading(true);
		// 	if (!loadingHome) {
		// 		setLoading(false);
		// 	}
		// }
	}, [type]);

	useEffect(() => {
		if (AuthData.lang.length) {
			http.setLang(AuthData.lang);
			// Promise.all(
			//   [new CategoriesService().getDropDown().then(res => {
			//     return res.data.map(item => {
			//       return {
			//         label: item.name[`${AuthData.lang}`] ? item.name[`${AuthData.lang}`] : item.name.en,
			//         value: item.id
			//       }
			//     })
			//   }),
			//   // new AreasService().getDropDown().then(res => {
			//   //   return res.data.map(item => {
			//   //     return {
			//   //       label: item.name[`${AuthData.lang}`] ? item.name[`${AuthData.lang}`] : item.name.en,
			//   //       value: item.id
			//   //     }
			//   //   })
			//   // }),
			//   // new UnitTypesService().getDropDown().then(res => {
			//   //   return res.data.map(item => {
			//   //     return {
			//   //       label: item.name[`${AuthData.lang}`] ? item.name[`${AuthData.lang}`] : item.name.en,
			//   //       value: item.id
			//   //     }
			//   //   })
			//   // }),
			//   // new FinishingTypesService().getDropDown().then(res => {
			//   //   return res.data.map(item => {
			//   //     return {
			//   //       label: item.name[`${AuthData.lang}`] ? item.name[`${AuthData.lang}`] : item.name.en,
			//   //       value: item.id
			//   //     }
			//   //   })
			//   // })
			// ]
			// ).then((values) => {
			//   dispatch(appendFilters({
			//     CategortiesOptions: values[0],
			//     // locationOptions: values[1],
			//     // unitTypeOptions: values[2],
			//     // finishingOptions: values[3]
			//   }))
			//

			// }).catch(e => {
			// })
		}
	}, [AuthData.lang]);

	useEffect(() => {
		const lang = localStorage.getItem("meras_lang") || "en";
		dispatch(
			authenticate({
				lang: lang,
			})
		);
	}, []);

	useEffect(() => {
		localStorage.setItem("meras_lang", AuthData.lang);
	}, [AuthData.lang]);

	const getAuthData = async () => {
		const token = await localStorage.getItem("token");
		const auth = await localStorage.getItem("auth");
		const authParsed = JSON.parse(auth);

		if (token && authParsed) {
			dispatch(
				authenticate({
					token: token,
					email: authParsed.email,
					user_name: authParsed?.user_name,
					userType: authParsed?.user_type,
					permissions: authParsed?.permissions || [],
					userId: authParsed?.id,
				})
			);
		}
	};

	useEffect(() => {
		if (AuthData.token && AuthData.userType === "user") {
			interestServices.getInterestIDs().then((response) => {
				if (response && response.status === SuccessOk) {
					const units = response.data
						.filter((item) => item.type === "Unit")
						.map((item) => parseInt(item.id));
					const resales = response.data
						.filter((item) => item.type === "Resale")
						.map((item) => parseInt(item.id));
					dispatch(
						setInterests({
							interestsResales: resales,
							interestsUnits: units,
						})
					);
				}
			});
		}
	}, [AuthData.token]);

	useEffect(() => {
		getAuthData();
	}, []);

	function getLayout() {
		let layoutCls = VerticalLayout;
		switch (props.layout.layoutType) {
			case "horizontal":
				layoutCls = HorizontalLayout;
				break;
			default:
				layoutCls = VerticalLayout;
				break;
		}
		return layoutCls;
	}

	const Layout = getLayout();

	return (
		<React.Fragment>
			<div className={`${AuthData.lang !== "ar" ? "" : "ar-wrapper"}`}>
				<ToastContainer />
				{type === "user" && loadingHome && <Loader />}
				<Router>
					<ScrollToTop />
					<Switch>
						{adminAuthRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={adminPrefix + route.path}
								routePrefix={adminPrefix}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								panel="admin"
								isAuthProtected={false}
							/>
						))}

						{adminRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={adminPrefix + route.path}
								routePrefix={adminPrefix}
								layout={Layout}
								component={route.component}
								key={idx}
								panel="admin"
								isAuthProtected={true}
								exact
							/>
						))}

						{salesDeveloperAuthRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={salesDeveloperPrefix + route.path}
								routePrefix={salesDeveloperPrefix}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								panel="sales-developer"
								isAuthProtected={false}
							/>
						))}
						{salesDeveloperRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={salesDeveloperPrefix + route.path}
								routePrefix={salesDeveloperPrefix}
								layout={Layout}
								component={route.component}
								key={idx}
								panel="sales-developer"
								isAuthProtected={true}
								exact
							/>
						))}

						{salesRepAuthRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={providerPrefix + route.path}
								routePrefix={providerPrefix}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								panel="provider"
								isAuthProtected={false}
							/>
						))}

						{salesRepRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={providerPrefix + route.path}
								routePrefix={providerPrefix}
								layout={Layout}
								component={route.component}
								key={idx}
								panel="provider"
								isAuthProtected={true}
								exact
							/>
						))}

						{websiteAuthRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={route.path}
								routePrefix={""}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								panel="user"
								isAuthProtected={false}
								exact
							/>
						))}

						{websiteRoutes.map((route, idx) => (
							<Authmiddleware
								setType={setType}
								path={route.path}
								routePrefix={""}
								layout={NonAuthBuyerLayout}
								component={route.component}
								key={idx}
								panel="user"
								isAuthProtected={true}
								exact
							/>
						))}
						{/* {NotFoundRoutes.map((route, idx) => (
                <Authmiddleware setType={setType}
                  path={route.path}
                  routePrefix={""}
                  layout={NonAuthBuyerLayout}
                  component={route.component}
                  key={idx}
                  panel='student'
                  isAuthProtected={false}
                />
              ))} */}
					</Switch>
				</Router>
			</div>
		</React.Fragment>
	);
};

App.propTypes = {
	layout: PropTypes.any,
};

const mapStateToProps = (state) => {
	return {
		layout: state.Layout,
	};
};

export default connect(mapStateToProps, null)(App);
// export default App
